import { LESection } from 'constants/loanApplication';

export const getLeSectionOptions = ({ taxesInsuranceEscrowed }) =>
  [
    { name: 'Origination Charges', cdSection: 'A', leSection: LESection.ORIGINATION_CHARGES },
    {
      name: 'Services Borrower Did Not Shop For',
      cdSection: 'B',
      leSection: LESection.SERVICES_YOU_CANNOT_SHOP_FOR,
    },
    {
      name: 'Services Borrower Did Shop For',
      cdSection: 'C',
      leSection: LESection.SERVICES_YOU_CAN_SHOP_FOR,
    },
    { name: 'TOTAL LOAN COSTS (Borrower-Paid)', cdSection: 'D' },
    {
      name: 'Taxes and Other Government Fees',
      cdSection: 'E',
      leSection: LESection.TRANSFER_TAXES,
    },
    { name: 'Prepaids', cdSection: 'F', leSection: LESection.PREPAIDS },
    {
      name: 'Initial Escrow Payment at Closing',
      description: !taxesInsuranceEscrowed ? 'Escrow Disabled' : undefined,
      cdSection: 'G',
    },
    { name: 'Other', cdSection: 'H', leSection: LESection.OTHER },
    { name: 'TOTAL OTHER COSTS (Borrower-Paid)', cdSection: 'I' },
    { name: 'TOTAL CLOSING COSTS (Borrower-Paid)', cdSection: 'J' },
  ].sort((a, b) => a.cdSection?.localeCompare(b.cdSection));
